module.exports = __webpack_public_path__ + "static/media/MOVR.081e0bc1.png";